<template>
  <n-modal class="modal-edit" :loading="$var('load')" @close="$emit('close')">
    <h3>Информация об участнике проекта</h3>
    <n-form @submit="submit">
      <n-items>
        <n-input title="Сотрудник" :value="user.fullName" text />
        <n-form-item v-if="participantFile" title="Приказ">
          <a :href="participantFile" target="_blank">Скачать</a>
        </n-form-item>
        <n-upload title="Новый приказ" v-bind="$form.input('file')" />
        <n-input title="Должность на проекте" v-bind="$form.input('position')" />
        <n-button type="submit">Сохранить</n-button>
        <!--        <n-upload title="Договор" :value.sync="file" />-->
        <n-form-item title="Полномочия" active>
          <n-divide class="table-tools" style="font-size: .8em">
            <n-button @click="$var('addAccess', true)">Добавить</n-button>
            <div></div>
          </n-divide>
          <n-table :data="accesses" :columns="columns" :loading="$var('loadAccesses')" style="font-size: .8em">
            <template #type="{item}">
              <span>{{ types[item.name] ? types[item.name].description : item.name }}</span>
            </template>
            <template #tools="{item}">
              <n-button flat round icon="trash" @click="remove(item)" />
            </template>
          </n-table>
        </n-form-item>
      </n-items>
      <n-divide>
        <div></div>
        <n-button style="margin-top: 10px;" @click="$emit('close')">Закрыть</n-button>
      </n-divide>
    </n-form>

    <modal-add-access v-if="$var('addAccess')" :project="project" :user="user" @submit="loadData" @close="$var('addAccess', false)" />
  </n-modal>
</template>

<script>
import ModalAddAccess from './ModalAddAccess'

export default {
  name: 'ModalEdit',
  components: { ModalAddAccess, },
  props: [ 'project', 'user', ],
  data() {
    return {
      file: null,
      participantFile: this.user.participant?.file,
      accesses: [],
      columns: [
        { name: 'type', title: 'Полномочие', },
        { name: 'tools', title: '', },
      ],
      types: {},
    }
  },
  created() {
    this.$form.init({
      position: this.user.participant.position,
      file: null,
    })
    this.loadData()
  },
  methods: {
    loadData() {
      this.$var('loadAccesses', true)
      $api.iq.accesses.participants.get(this.project.id, this.user.id)
        .with({ user: null, }).then((result) => {
          this.accesses = result.data.content
        }).finally(() => {
          this.$var('loadAccesses', false)
        })
      $api.iq.accesses.getByName().then((response) => {
        this.types = response.data.content
      })
    },
    submit() {
      this.$var('load', true)
      const file = this.$form.get('file')
      if (file) {
        $api.files.create({ file, }).then((response) => {
          this.save(response.data.content)
        })
      } else {
        this.save()
      }
    },
    save(file = undefined) {
      const data = {
        position: this.$form.get('position'),
        file: file ? file.id : undefined,
      }
      $api.iq.participants.edit(this.project.id, this.user.id, data).then((response) => {
        this.$form.set('file', null)
        this.$emit('reload')
        this.participantFile = file.src
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove(access) {
      this.$var('load', true)
      $api.iq.accesses.delete(access.id).then(() => {
        this.loadData()
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .modal-edit {
    .position {
      width: 100%;
      display: flex;
      align-items: flex-end;
      &>.n-button {
        margin-left: 10px;
        font-size: .8em;
      }
    }
    &::v-deep > .n-wrapper {
      width: 800px;
      left: calc(50% - 400px);
    }
  }
</style>
